import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getPastMessages } from "../../redux/Chats/PastChatsActions";
import DragPastChatHistory from "./dragPastChatHistory";

const DragPastChat = ({ currentActiveVisitorData }) => {
    const usertoken = useSelector((state) => state.Auth.token);
    const pastChats = useSelector((state) => state.PastChat.data);
    const pastChatsLoading = useSelector((state) => state.PastChat.isLoading);
    const [messages, setMessages] = useState([]);
    const [expandedKey, setExpandedKey] = useState(null);
    const dispatch = useDispatch();
    const onExpand = (_, key) => {
        setExpandedKey((prev) => {
            const newKey = key.key;
            if (prev !== newKey) {
                return newKey;
            }
            return null;
        });
    };


    useEffect(() => {
        if (!currentActiveVisitorData?.unique_id) return;
        dispatch(
            getPastMessages({ unique_id: currentActiveVisitorData.unique_id }, usertoken)
        );
    }, [currentActiveVisitorData?.unique_id, dispatch, usertoken]);

    const columns = [
        {
            title: "Agent",
            dataIndex: "agent",
            key: "agent",
            width: 132,
            ellipsis: true,
        },
        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            width: 260,
            ellipsis: true,
        },
        {
            title: "Sentiment",
            dataIndex: "sentiment",
            key: "sentiment",
            width: 128,
            ellipsis: true,
        },
        {
            title: "",
            key: "expandHint",
            width: 44,
            align: "center",
            render: (_, record) => (
                <span className="chatVisitorDrawer__pastChatExpandHint">
                    {record?.key === expandedKey ? "−" : "+"}
                </span>
            ),
        },
    ];
    // const data = [];
    const data = pastChats?.past_conversations?.map((message, index) => {
        return {
            key: index,
            id: message._id,
            unique_id: currentActiveVisitorData?.unique_id,
            agent: message?.agentParticipants?.length > 0 ? message?.agentParticipants?.[0]?.sudoName : "No Agent",
            sentiment: message?.sentiment,
            message: message?.latest_message?.message,
            convoMessages: message?.messages,
            createdAt: message?.createdAt
        }
    });

    return (
        <div className="chatVisitorDrawer__pastChat">
            <Table
                className="chatVisitorDrawer__pastChatTable"
                columns={columns}
                dataSource={data}
                pagination={false}
                size="small"
                height={1000}
                tableLayout="auto"
                expandRowByClick={true}
                expandIconColumnIndex={-1}
                loading={pastChatsLoading}
                expandable={{
                    expandedRowRender: (record) => (
                        <DragPastChatHistory record={record} pastChats={pastChats} setExpandedKey={setExpandedKey} />
                    ),
                    onExpand: onExpand,
                    expandedRowKeys: expandedKey != null ? [expandedKey] : []
                }}
                scroll={{ x: "max-content" }}
            />
        </div>
    );
};

export default DragPastChat;
